import { Footer } from "../../../Footer/Footer"
import { HerosectionsAll } from "../../../HeroSectionAll/HerosectionsAll"
import { Header } from "../../../IndexPage/Header/Header"


export const Seminars = () => {
    return (
        <>
 <div className="container-fluid">
            <div className="row " style={{ background: '#fff' }} onLoad={() => window.scrollTo(0, 0)}>
                <div className="col-12">
                    <Header actives="Seminars" />
                    <HerosectionsAll ScreenName="Seminars" ScreenSearch="Lectures" />

                    <div className="row col-lg-9 mx-auto p-2 p-lg-5 my-5">
                        <div className="col-12 p-lg-5 faint p-4" style={{textAlign: 'justify'}}>
                            <h5 className="fw-bold gray_color pb-3">Seminars</h5>
                            <p>Marine insurance includes interconnected topics and hence one - line solution is very rare.  
                             <br />
                            There is a need for brainstorming discussions in the presence of industry experts. We arrange workshops and seminars that encourage lateral thinking through interactive participation. </p>
                        </div>
                    </div>

                    <Footer />
                </div>
            </div>
</div>

        </>
    )
}
